import {
  Flexbox, Form, Modal, Styles,
} from '@/components'
import yup from '@/lib/yupPt'
import partnerLicensings from '@/services/api/partnerLicensings'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { toast } from 'react-toastify'

// import { Container } from './styles';

const schema = yup.object().shape({
  osmBaseUrl: yup.string().url().required(),
  osmUser: yup.string().required(),
  osmPassword: yup.string().required(),
  osmDepartamentoId: yup.number().required(),
})
function OsmIntegrationForm({ partnerLicensingId }) {
  const [loading, setLoading] = useState(false)
  const [active, setActive] = useState(false)

  async function onSubmit(values) {
    try {
      setLoading(true)
      await partnerLicensings.update(partnerLicensingId, values)
      toast.success('Configurações de integração com OS-m atualizadas')
      setActive(false)
    } catch (e) {
      setLoading(false)
      toast.error(e?.message)
    }
  }

  return (
    <span className="text-left">
      <button
        onClick={() => setActive(true)}
        className="btn btn-sm btn-action btn-primary tooltip tooltip-left mr-2"
        data-tooltip="Configurar OS-m"
        type="button"
      >
        <i className="fas fa-cogs" />
      </button>
      {
        active && (
          <fieldset disabled={loading}>
            <Form.Formik
              initialValues={{}}
              validationSchema={schema}
              onSubmit={onSubmit}
            >
              {
                ({
                  errors, touched, isValid, dirty,
                }) => (
                  <Form.ValidationForm>
                    <Modal.Base className="active">
                      <Modal.Overlay onClick={() => setActive(false)} />
                      <Modal.Container>
                        <Modal.Header>
                          <Modal.Close onClick={() => setActive(false)} />
                          <Modal.Title>Motivo do cancelamento</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <Modal.Content>
                            <Flexbox.Columns>
                              <Flexbox.Column className="col-12">
                                <Form.Group className={`${touched?.osmBaseUrl && errors?.osmBaseUrl ? 'has-error' : ''}`}>
                                  <Form.Label htmlFor="osmBaseUrl">URL da API <span className="text-error">*</span></Form.Label>
                                  <Form.ValidationField
                                    name="osmBaseUrl"
                                    autoFocus
                                    id="osmBaseUrl"
                                    autoComplete="off"
                                    placeholder="URL da API"
                                  />
                                  {
                                    touched?.osmBaseUrl && errors?.osmBaseUrl
                                      ? <Form.Hint>{errors.osmBaseUrl}</Form.Hint> : null
                                  }
                                </Form.Group>
                              </Flexbox.Column>
                              <Flexbox.Column className="col-6 col-sm-12">
                                <Form.Group className={`${touched?.osmUser && errors?.osmUser ? 'has-error' : ''}`}>
                                  <Form.Label htmlFor="osmUser">Usuário <span className="text-error">*</span></Form.Label>
                                  <Form.ValidationField
                                    name="osmUser"
                                    id="osmUser"
                                    autoComplete="off"
                                    placeholder="Usuário"
                                  />
                                  {
                                    touched?.osmUser && errors?.osmUser
                                      ? <Form.Hint>{errors.osmUser}</Form.Hint> : null
                                  }
                                </Form.Group>
                              </Flexbox.Column>
                              <Flexbox.Column className="col-6 col-sm-12">
                                <Form.Group className={`${touched?.osmPassword && errors?.osmPassword ? 'has-error' : ''}`}>
                                  <Form.Label htmlFor="osmPassword">Senha <span className="text-error">*</span></Form.Label>
                                  <Form.ValidationField
                                    name="osmPassword"
                                    id="osmPassword"
                                    autoComplete="off"
                                    placeholder="Senha"
                                  />
                                  {
                                    touched?.osmPassword && errors?.osmPassword
                                      ? <Form.Hint>{errors.osmPassword}</Form.Hint> : null
                                  }
                                </Form.Group>
                              </Flexbox.Column>
                              <Flexbox.Column className="col-12">
                                <Form.Group className={`${touched?.osmDepartamentoId && errors?.osmDepartamentoId ? 'has-error' : ''}`}>
                                  <Form.Label htmlFor="osmDepartamentoId">ID do Departamento <span className="text-error">*</span></Form.Label>
                                  <Form.ValidationField
                                    name="osmDepartamentoId"
                                    id="osmDepartamentoId"
                                    autoComplete="off"
                                    placeholder="ID do Departamento"
                                  />
                                  {
                                    touched?.osmDepartamentoId && errors?.osmDepartamentoId
                                      ? <Form.Hint>{errors.osmDepartamentoId}</Form.Hint> : null
                                  }
                                </Form.Group>
                              </Flexbox.Column>
                            </Flexbox.Columns>
                          </Modal.Content>
                        </Modal.Body>
                        <Modal.Footer>
                          <Styles.Button
                            type="submit"
                            className="btn-primary"
                            disabled={!dirty || !isValid}
                          >
                            <i className="fas fa-save" />
                            &nbsp;Salvar
                          </Styles.Button>
                        </Modal.Footer>
                      </Modal.Container>
                    </Modal.Base>
                  </Form.ValidationForm>
                )
              }
            </Form.Formik>
          </fieldset>
        )
      }
    </span>
  )
}

OsmIntegrationForm.propTypes = {
  partnerLicensingId: PropTypes.number.isRequired,
}

export default OsmIntegrationForm
